<template>
    <section>
        <v-parallax src="@/assets/hero.jpg" height="620">
            <v-layout column align-center justify-center class="white--text">

            <h1 class="black--text display-1 text-center font-weight-black" >「RPAをすぐ治したい」にお応え！</h1><br/>

            <div class="title text-center black--text">～ リアルタイム遠隔RPAサポート ～</div>
            <v-btn
                class="mt-6 title"
                color="yellow darken-4"
                dark
                x-large
                ref="button"
                @click="$vuetify.goTo('#tester_recruit', options)"
            >今すぐ無料利用</v-btn>
            </v-layout>
        </v-parallax>
    </section>
</template>

<script>
import * as easings from 'vuetify/es5/services/goto/easing-patterns'
export default {
  data(){
    return{
        fixed: true,
        title:"ＲＰＡダッシュ！",
        type: 'number',
        number: 9999,
        selector: '#first',
        selected: 'Button',
        elements: ['Button', 'Radio group'],
        duration: 1000,
        offset: 500,
        easing: 'easeInOutCubic',
        easings: Object.keys(easings),
    }
  },
    computed: {
      target () {
        const value = this[this.type]
        if (!isNaN(value)) return Number(value)
        else return value
      },
      options () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing,
        }
      },
      element () {
        if (this.selected === 'Button') return this.$refs.button
        else if (this.selected === 'Radio group') return this.$refs.radio
      },
    }
};
</script>
